import type { Weekday } from '../types';
import { WEEKDAY_LABEL } from '../types';
import type { InvalidScheduleEntry } from './findInvalidScheduleEntries';

/**
 * 時刻が片側だけ未入力の曜日一覧を、ユーザー提示用のエラーメッセージに整形する。
 * entries は1件以上であることを前提とする。
 */
export const formatMissingEdgesMessage = (entries: InvalidScheduleEntry[]): string => {
  const details = entries
    .map(({ day, missingEdge }) => `${WEEKDAY_LABEL[day]}曜日の${missingEdge === 'from' ? '開始時刻' : '終了時刻'}`)
    .join('、');
  return `${details}が未入力です`;
};

/**
 * 開始時刻が終了時刻以降になっている曜日一覧を、ユーザー提示用のエラーメッセージに整形する。
 * days は1件以上であることを前提とする。
 */
export const formatInvertedDaysMessage = (days: Weekday[]): string =>
  `${days.map(day => WEEKDAY_LABEL[day]).join('、')}曜日は開始時刻を終了時刻より前にしてください`;
